import React, { useContext, useEffect, useState } from "react";
import { instance } from "utils/axios";
import { DatePicker, Segmented, Button } from "antd";
import { AuthContext } from "contexts";
import moment from "moment";
import { MainTable } from "components";
import CustomerHistory from "./CustomerHistory";

const { RangePicker } = DatePicker;

const WoundDashboard = ({}) => {
  const { state, action } = useContext(AuthContext);

  const [countData, setCountData] = useState({});
  const [loading, setLoading] = useState(false);
  const [symptonData, setSymptonData] = useState([]);
  const [bacData, setBacData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [patData, setPatData] = useState([]);
  const [openHistory, setOpenHistory] = useState(false);
  const [customerId, setCustomerId] = useState(null);

  // --- Горим: date | month | year  (UI дээр "Өдөр | Сар | Жил")
  const [pickerType, setPickerType] = useState("month");
  // --- Анхдагч нь энэ сарын 1 → сүүлийн өдөр
  const [range, setRange] = useState([
    moment().startOf("month"),
    moment().endOf("month"),
  ]);

  // UI format-аа picker-аас хамааруулна
  const fmt =
    pickerType === "date"
      ? "YYYY-MM-DD"
      : pickerType === "month"
      ? "YYYY-MM"
      : "YYYY";

  // Горимын Segmented → picker солино, range-ээ тухайн нэгжээр тааруулна
  const applyMode = (modeLabel) => {
    const now = moment();
    if (modeLabel === "Өдөр") {
      setPickerType("date");
      setRange([now.clone().startOf("day"), now.clone().endOf("day")]);
    } else if (modeLabel === "Сар") {
      setPickerType("month");
      setRange([now.clone().startOf("month"), now.clone().endOf("month")]);
    } else if (modeLabel === "Жил") {
      setPickerType("year");
      setRange([now.clone().startOf("year"), now.clone().endOf("year")]);
    }
  };

  // Горимын Segmented-тай value sync
  const segmentedValue =
    pickerType === "date" ? "Өдөр" : pickerType === "month" ? "Сар" : "Жил";

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range]);

  const fetchData = () => {
    setLoading(true);
    const [start, end] = range;
    const qs = `startDate=${start.format("YYYY-MM-DD")}&endDate=${end.format(
      "YYYY-MM-DD"
    )}`;

    instance
      .get(`/wound/dashboard/countdata?${qs}`)
      .then((res) => {
        setCountData(res.data || {});
      })
      .catch(() => {})
      .finally(() => setLoading(false));

    instance
      .get(`/wound/dashboard/symptons?${qs}`)
      .then((res) => setSymptonData(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));

    instance
      .get(`/wound/dashboard/bacteriology?${qs}`)
      .then((res) => setBacData(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
    instance
      .get(`/wound/dashboard/patient?${qs}`)
      .then((res) => setPatData(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
    instance
         .get(`/wound/dashboard/material?${qs}`)
         .then((res) => setMaterialData(res.data || []))
         .catch(() => {})
         .finally(() => setLoading(false));
  };
  //  const handleHistory = (customerId) => {
  const handleHistory = (row) => {
    setCustomerId(row.customerId);
    setOpenHistory(true);
  };
  return (
    <div className="px-1 md:px-5">
      <div className="grid grid-cols-3 md:grid-cols-6 gap-5 items-center">
        {/* Хоёр огноо + горим */}
        <RangePicker
          allowClear={false}
          picker={pickerType} // ← Өдөр/Сар/Жил горим
          value={range}
          onChange={(vals) => {
            if (!vals) return;
            const [s, e] = vals;
            // Сонгосон утгыг тухайн нэгжийн хил рүү тэгшлээд хадгална
            setRange([
              s.clone().startOf(pickerType),
              e.clone().endOf(pickerType),
            ]);
          }}
          format={fmt}
        />

        <Segmented
          options={["Өдөр", "Сар", "Жил"]}
          value={segmentedValue}
          onChange={applyMode}
        />
      </div>

      <div className="grid grid-cols-12 gap-5 mt-5"></div>

      {/* KPI картууд */}
      <div className="grid grid-cols-24 gap-2">
        {[
          { label: "Нийт", value: countData?.totalCount },
          { label: "Нийт боолт", value: countData?.woundCount },
          { label: "Дундаж боолт", value: countData?.woundAvg },
          { label: "Хийлгэж байгаа", value: countData?.activeCount },
          { label: "Дууссан", value: countData?.finishCount },
          { label: "Хэвтэн", value: countData?.khCnt ?? 0 },
          { label: "Амбулатори", value: countData?.aCnt },
          { label: "Өөрчлөлттэй", value: countData?.wsChCount ?? 0 },
          { label: "Гуурсны тоо", value: countData?.catCnt },
          { label: "Гуурс авсан тоо", value: countData?.catRCnt },
        ].map((kpi, i) => (
          <div
            key={i}
            className="col-span-8 md:col-span-4 shadow p-4 rounded-lg bg-white flex items-center gap-6"
          >
            <div>
              <div className="text-base text-muted">{kpi.label}</div>
              <div className="font-medium text-3xl">
                {Intl.NumberFormat().format(kpi.value || 0)}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Хүснэгтүүд */}
      <div className="grid grid-cols-12 gap-5 mt-5">
        <div className="bg-white rounded-lg shadow p-3 flex flex-col col-span-12 md:col-span-4">
          <div className="border rounded-lg overflow-hidden flex-1">
            <MainTable
              dataTable={symptonData}
              columns={[
                {
                  title: "Нэр",
                  dataIndex: "labelMn",
                  key: "labelMn",
                  width: 120,
                  fixed: "left",
                },
                {
                  title: "Тоо",
                  dataIndex: "boolValue",
                  key: "boolValue",
                  width: 50,
                  fixed: "center",
                },
              ]}
              loading={loading}
              title="Шинж тэмдэг"
              servicetypeid={1}
            />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-3 flex flex-col col-span-12 md:col-span-4">
          <div className="border rounded-lg overflow-hidden flex-1">
            <MainTable
              dataTable={bacData}
              columns={[
                {
                  title: "Хэвлийн гуурснаас",
                  dataIndex: "cCount",
                  key: "cCount",
                  fixed: "center",
                },
                {
                  title: "Үүсгэгч",
                  dataIndex: "cP",
                  key: "cP",
                  fixed: "center",
                },
                {
                  title: "Шархнаас",
                  dataIndex: "wCount",
                  key: "wCount",
                  fixed: "center",
                },
                {
                  title: "Үүсгэгч",
                  dataIndex: "wP",
                  key: "wP",
                  fixed: "center",
                },
              ]}
              loading={loading}
              title="Бактериологийн тоо"
            />
          </div>
        </div>{" "}
        <div className="bg-white rounded-lg shadow p-3 flex flex-col col-span-12 md:col-span-4">
          <div className="border rounded-lg overflow-hidden flex-1">
            <MainTable
              dataTable={materialData}
              columns={[
                {
                  title: "Материал",
                  dataIndex: "name",
                  key: "name",
                  fixed: "center",
                },
                {
                  title: "Тоо",
                  dataIndex: "qty",
                  key: "qty",
                  fixed: "center",
                },
              ]}
              loading={loading}
              title="Материал зарцуулалт"
            />
          </div>
        </div>{" "}
        <div className="bg-white rounded-lg shadow p-3 flex flex-col col-span-12 ">
          <div className="border rounded-lg overflow-hidden flex-1">
            <MainTable
              dataTable={patData}
              columns={[
                {
                  title: "Өвчтөн",
                  key: "fullname",
                  dataIndex: "firstname",
                  width: 160,
                  fixed: "left",
                  render: (_, r) =>
                    `${r.lastname ?? ""} ${r.firstname ?? ""}`.trim(),
                },
                {
                  title: "Регистр",
                  dataIndex: "regno",
                  key: "regno",
                  width: 120,
                },
                {
                  title: "Эхний төрөл",
                  dataIndex: "firstType", // wp.firstType
                  key: "firstType",
                  width: 120,
                },
                {
                  title: "Төрөл",
                  dataIndex: "type", // wp.type
                  key: "type",
                  width: 120,
                },
                {
                  title: "Мэс заслын төрөл",
                  dataIndex: "stName",
                  key: "stName",
                  width: 120,
                },
                {
                  title: "Өөрчлөгдсөн өдөр",
                  dataIndex: "wChangeDay", // wp.wChangeDay
                  key: "wChangeDay",
                  width: 140,
                  align: "center",
                  render: (v) =>
                    v != null ? Intl.NumberFormat().format(v) : "—",
                },

                {
                  title: "Action",
                  dataIndex: "history",
                  key: "history",
                  width: 100,
                  render: (status, row) => {
                    return (
                      <div className="flex items-center gap-5">
                        <Button
                          disabled={status}
                          size="small"
                          onClick={() => handleHistory(row)}
                        >
                          <div className="flex items-center gap-2">Түүх</div>
                        </Button>
                      </div>
                    );
                  },
                },
                {
                  title: "Боолт хийлгэсэн тоо",
                  dataIndex: "monitoring_count", // COUNT(DISTINCT wm.id)
                  key: "monitoring_count",
                  width: 140,
                  align: "center",
                  render: (v) => Intl.NumberFormat().format(v ?? 0),
                },
                {
                  title: "Өөрчлөлттэй өдрийн тоо",
                  dataIndex: "changed_monitoring_count", // COUNT... status='Өөрчлөлттэй'
                  key: "changed_monitoring_count",
                  width: 180,
                  align: "center",
                },
                {
                  title: "Өөрчлөлттэй Шинж тэмдэг",
                  dataIndex: "symptoms", // GROUP_CONCAT(... wsm.labelMn)
                  key: "symptoms",
                  width: 260,
                  render: (v) => {
                    const items = (v ?? "")
                      .split(",")
                      .map((s) => s?.trim())
                      .filter(Boolean);

                    if (!items.length) return "—";

                    // урт байвал 3-ыг харуулж, үлдсэнийг tooltip маягаар
                    const head = items.slice(0, 3);
                    const rest = items.slice(3);

                    return (
                      <div className="flex flex-wrap gap-1">
                        {head.map((t, i) => (
                          <span
                            key={i}
                            className="px-2 py-0.5 rounded-full bg-gray-100 text-gray-700 text-xs"
                          >
                            {t}
                          </span>
                        ))}
                        {rest.length > 0 && (
                          <span
                            className="px-2 py-0.5 rounded-full bg-gray-50 text-gray-500 text-xs"
                            title={rest.join(", ")}
                          >
                            +{rest.length}
                          </span>
                        )}
                      </div>
                    );
                  },
                },
              ]}
              loading={loading}
              title="Үйлчлүүлэгчийн мэдээ"
            />
          </div>
        </div>
      </div>
      <CustomerHistory
        open={openHistory}
        onClose={() => setOpenHistory(false)} // Pass a function to handle closing
        customerId={customerId}
      />
    </div>
  );
};

export default WoundDashboard;
